import Modal from 'components/global/Modal'
import { Row } from 'components/grid'
import { graphql, useStaticQuery } from 'gatsby'
import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image'
import React from 'react'
import { Carousel } from 'react-responsive-carousel'
import 'react-responsive-carousel/lib/styles/carousel.min.css'
import MaterialButton from './MaterialButton'

interface Props {
	pages?: { id: string; gatsbyImageData: IGatsbyImageData }[]
	cover?: IGatsbyImageData
}

const PacingGuideK = ({ pages, cover }: Props) => {
	const [show, setShow] = React.useState(false)
	const handleClose = () => setShow(false)
	const handleShow = () => setShow(true)

	const data = useStaticQuery(graphql`
		query {
			contentfulModal(name: { eq: "Pacing Guide" }) {
				title
				description {
					description
				}
			}
		}
	`)

	const title = data.contentfulModal.title

	return (
		<React.Fragment>
			<MaterialButton onClick={handleShow} image={cover} title={title} />
			<Modal wide title={title} isOpen={show} handleClose={handleClose}>
				<Row>
					<Carousel showThumbs={false} dynamicHeight showStatus={false} infiniteLoop>
						{pages &&
							pages.map((page) => {
								return (
									<div key={page.id}>
										<GatsbyImage image={page.gatsbyImageData} alt="grade kpacing guide" className="block w-full" />
									</div>
								)
							})}
					</Carousel>
				</Row>
			</Modal>
		</React.Fragment>
	)
}

export default PacingGuideK
